import { TESTIMONIALS } from "../../lib/testimonials";
import { TestimonialBar } from "./TestimonialBar";

export const NotScared = () => {
  return (
    <section
      className="relative py-28 md:py-40 bg-[#F7E9EC] border-y border-[#EDD9DE]"
      data-testid="not-scared-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-light leading-[1.05] tracking-tight text-[#3B2630] text-center">
          I know you&rsquo;re not scared of
          <span className="italic text-[#C9587E]"> success</span>&hellip;
        </h2>
        <p className="font-serif italic text-3xl md:text-5xl text-[#3B2630] text-center mt-8 leading-snug">
          But you&rsquo;re scared of what it&rsquo;s cost you.
        </p>

        <div className="warm-divider-h my-14 max-w-md mx-auto" />

        <div className="font-body text-base md:text-lg text-[#6B5058] leading-relaxed space-y-5 max-w-2xl mx-auto">
          <p>
            You&rsquo;ve been there before, or watched someone else get there,
            and made yourself a promise:
          </p>
          <p className="font-serif italic text-2xl md:text-3xl text-[#3B2630] !my-8 leading-snug text-center">
            &ldquo;I will never sacrifice my health or nervous system to
            succeed.&rdquo;
          </p>
          <p>
            You want to grow your income without it growing at the expense of
            your nervous system.
          </p>
          <p>
            No more sacrificing time with your family or friends to build your
            empire.
          </p>
          <p className="!mt-8">I know. I get it.</p>
          <p>
            Hi &mdash; auto immune woman who&rsquo;s worked with a Nervous
            System Expert for years.
          </p>
          <p className="font-serif italic text-xl md:text-2xl text-[#C9587E] leading-snug">
            Because I did that sh*t&hellip; and I won&rsquo;t ever again.
          </p>
          <p className="!mt-8">
            I know how to help women move on ideas without the fear of getting
            it wrong publicly, because you can&rsquo;t. It either works or you
            learn.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-24">
        <p className="font-body uppercase tracking-[0.3em] text-[10px] text-[#C9587E] font-semibold mb-10 text-center">
          My clients have a few things to say&hellip;
        </p>
        <TestimonialBar
          testid="clients-testimonials"
          testimonials={[
            TESTIMONIALS.confidence,
            TESTIMONIALS.moneyMindset,
            TESTIMONIALS.boldJump,
          ]}
        />
      </div>
    </section>
  );
};
